import {
  AiOutlineArrowRight,
} from "react-icons/ai";

import { Link } from "react-router-dom";

const OurStores = () => {


  const customerNotice26 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Notice_post_settlement_thumbnail.jpg"
  const customerNotice25 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/1226_IZB_tax_noticve_thumbnail.png"
  const customerNotice24 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/1901_IZB_old_currency_thumbnail.png"
  const customerNotice27 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB-Notice-post-settlement-thumbnail.png"
  const customerNotice28 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB%20Notice%20post%20thumbnail-1.jpg.jpeg"
  const customerNotice29 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB%20Notice%20post%20settlement%20thumbnail.png"
  const customerNotice30 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB%20Notice%20post%20thumbnail-1.jpg%20(1).jpeg"
  const customerNotice32 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/0415_IZB%20it%20ad%20paper%20thumbnail.jpg.jpeg"
  const customerNotice33 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/0415_IZB%20MPR%20thumbnail.jpg.jpeg"
  const customerNotice34 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/0415_IZB%20KYC%20thumbnail.jpg.jpeg"
  const customerNotice35 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB%20cheque%20thumbnail.png"
  const customerNotice36 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/0415_IZB%20it%20ad%20paper%20thumbnail1.jpeg"

  return (
    <section>
      <div className="container notice-and-announcements">
        <div className="row">
          <div className="container">
            <div className="heading py-2">
              <h2 className="text-center">Notice / Announcements</h2>
              {/* <p className="text-center">All News And Updates</p> */}
            </div>
            <div
              className="py-4 read-more-flot-btn"
            // style={{ float: "right"}}
            >
              <Link
                to="/NoticeAnnouncements"
                className="text-white rounded px-3 py-1"
                style={{ backgroundColor: "#9E1B1E" }}
              >
                See More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
              </Link>
            </div>
          </div>
          <div className="col-xl-4 col-lg-4">
            <div
              className="single-blog-style1 wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/0617_%20IZB%20property%20sale%20ad%20copy.pdf" target="_blank" rel="noreferrer">
                <div className="img-holder">
                  <div className="inner">
                    <img className="imgresize" src={customerNotice36} alt="" />
                    <div className="overlay-icon"></div>
                  </div>
                </div>
              </a>
              <div className="text-holder">
                <h3 className="blog-title">
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/0617_%20IZB%20property%20sale%20ad%20copy.pdf" target="_blank" rel="noreferrer">INVITATION TO BID: SALE OF PROPERTIES (MORTGAGEE IN POSSESSION)</a><br />
                  <span style={{ fontSize: "15px", color: "gray" }}>June 19, 2026</span>
                </h3>
                <p style={{ marginBottom: "0rem" }}>
                  Indo Zambia Bank Limited as mortgagees in possession is inviting bids from interested parties for purchase of the following properties on "as is where is basis". Bidding Documents available at ZMW500 non-refundable fee.
                </p>
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/0617_%20IZB%20property%20sale%20ad%20copy.pdf" target="_blank" rel="noreferrer">
                  <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                  </h5>
                </a>
                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
              </div>
            </div>
          </div>

          <div className="col-xl-4 col-lg-4">
            <div
              className="single-blog-style1 wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB%20Cheque%20Notice.pdf" target="_blank" rel="noreferrer">
                <div className="img-holder">
                  <div className="inner">
                    <img className="imgresize" src={customerNotice35} alt="" />
                    <div className="overlay-icon"></div>
                  </div>
                </div>
              </a>
              <div className="text-holder">
                <h3 className="blog-title">
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB%20Cheque%20Notice.pdf" target="_blank" rel="noreferrer">DISCONTINUATION OF CHEQUES AS A PAYMENT INSTRUMENT IN ZAMBIA</a><br />
                  <span style={{ fontSize: "15px", color: "gray" }}>May 26, 2026</span>
                </h3>
                <p style={{ marginBottom: "0rem" }}>
                  Cheques will cease to be a payment instrument in Zambia effective 26 June 2026. The last day to deposit cheques is 24 June 2026, with final interbank clearing on 26 June 2026.
                </p>
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB%20Cheque%20Notice.pdf" target="_blank" rel="noreferrer">
                  <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                  </h5>
                </a>
                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
              </div>
            </div>
          </div>

          <div className="col-xl-4 col-lg-4">
            <div
              className="single-blog-style1 wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB%20KYC%20Notice.pdf" target="_blank" rel="noreferrer">
                <div className="img-holder">
                  <div className="inner">
                    <img className="imgresize" src={customerNotice34} alt="" />
                    <div className="overlay-icon"></div>
                  </div>
                </div>
              </a>
              <div className="text-holder">
                <h3 className="blog-title">
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB%20KYC%20Notice.pdf" target="_blank" rel="noreferrer">FINAL REMINDER: MANDATORY KYC UPDATE</a><br />
                  <span style={{ fontSize: "15px", color: "gray" }}>May 21, 2026</span>
                </h3>
                <p style={{ marginBottom: "0rem" }}>
                  The Bank is conducting a mandatory compliance exercise. All account holders are required to update their KYC documentation before 31st May 2026 to avoid transaction restrictions effective 1st June 2026.
                </p>
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB%20KYC%20Notice.pdf" target="_blank" rel="noreferrer">
                  <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                  </h5>
                </a>
                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default OurStores;
